import React from 'react';
import './Project.scss';
import OtherPages from '../../Components/OtherPages/OtherPages'
import projectImage from '../../Assets/project.jpeg'
import Button from '../../Components/Button/Button';
import { GoProjectTemplate } from "react-icons/go";
import logo1 from '../../Assets/projectlogo/logo1.png';
import logo2 from '../../Assets/projectlogo/logo2.webp';
import logo3 from '../../Assets/projectlogo/logo3.png';
import logo4 from '../../Assets/projectlogo/logo4.png';
import logo5 from '../../Assets/projectlogo/logo5.jpeg';
import logo6 from '../../Assets/projectlogo/logo6.png';
function Project() {

  const logolist = [
    // Add logo image paths or components here
    {
      id: 1,
      image: logo1,
      alt: 'Logo 1',
    },
    {
      id: 2,
      image: logo2,
      alt: 'Logo 2',
    },
    {
      id: 3,
      image: logo3,
      alt: 'Logo 3',
    },
    {
      id: 4,
      image: logo4,
      alt: 'Logo 4',
    },
    {
      id: 5,
      image: logo5,
      alt: 'Logo 5',
    },
    {
      id: 6,
      image: logo6,
      alt: 'Logo 1',
    },
    // {
    //   id: 7,
    //   image: logo2,
    //   alt: 'Logo 2',
    // },
    // {
    //   id: 8,
    //   image: logo3,
    //   alt: 'Logo 3',
    // },
    // {
    //   id: 9,
    //   image: logo4,
    //   alt: 'Logo 4',
    // }
  ];
  return (
    <div>
      <OtherPages
        pageName="Our Projects"
      />

      <div className='projectContainer'>
        <div className='container'>
          <div className="row g-4">
            <div className='col-lg-6 col-md-12 col-sm-12'>
              <div className='projectImage'>
                <img src={projectImage} alt="project" className='img-fluid' />
              </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-12'>
              <div className='projectText'>
                <div className="sub-heading">Our Portfolio of Projects </div>
                <div className="main-heading">
                  Exceeding our <span>clients’ </span> expectations.
                </div>

                <div className='page-text'>
                  Our client portfolio speaks volumes. With our proven expertise, we’ve consistently delivered exceptional value and operational excellence across the global energy sector. Our track record is reflected in the caliber of companies we serve — We take pride in providing tailored, high-impact solutions that meet the evolving demands of our clients and the industry.
                </div>

                <Button text="See Project Below" scrollToId="projects-section" />
              </div>
            </div>
          </div>
        </div>

        {/* another section here */}
        <div className="projectBanner">
          <div className='container'>
            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-7 g-4 text-center">
              {logolist.map((logo, index) => (
                <div
                  key={index}
                  // className="img-fluid logo-uniform"
                  className="col-6 col-sm-4 col-md-3 col-lg"
                >
                  <div className="logo-box">
                    <img src={logo.image} alt="client logo" className="img-fluid" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* another section here */}
        <div className='projectCard' id="projects-section">
          <div className='container'>
            <div className="row g-5">
              {/* Project cards will go here */}
              <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='projectCardContent'>
                  <div className='top'>
                    <GoProjectTemplate className='projectIcon' />
                    <div className='projectTitle'>
                      <h6>Commenced 2025</h6>
                      <h5>PLATFORM PETROLEUM  </h5>
                    </div>
                  </div>

                  <div className="details">
                    <ul>
                      <li>Provision of barges for crude evacuation after the EWT of the Kuri field in PPL 222</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='projectCardContent'>
                  <div className='top'>
                    <GoProjectTemplate className='projectIcon' />
                    <div className='projectTitle'>
                      <h6>Commenced 2024</h6>
                      <h5>ELCREST E&P   </h5>
                    </div>
                  </div>

                  <div className="details">
                    <ul>
                      <li>Turnkey Crude Evacuation. </li>
                      <li>Daily evacuation of crude oil into the pipeline manifold to the Forcados terminal.</li>
                      <li>Provision of two (2) low draft (max. 1.8m draft), 1,000MT capacity Damen barges.</li>
                      <li>With increased production, the barge was replaced with a low-draft tanker to increase daily evacuation.</li>

                    </ul>
                  </div>
                </div>
              </div>

              <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='projectCardContent'>
                  <div className='top'>
                    <GoProjectTemplate className='projectIcon' />
                    <div className='projectTitle'>
                      <h6>Commenced 2017</h6>
                      <h5>GEIL     </h5>
                    </div>
                  </div>

                  <div className="details">
                    <ul>
                      <li>Turnkey Crude Evacuation. </li>
                      <li>Monthly evacuation of 200,000+ bbls.</li>
                      <li>Construction of PLEM and CALM Bouy Infrastructure.</li>
                      <li>Provision of two (2) low draft Marine Assets (Shuttle tankers).</li>
                      <li>Provision of two (2) AHT vessels for operational support.</li>
                      <li>Barging of crude to FSO Ailsa Craig1 at IMA field.</li>
                      <li>Commercial audit of the entire crude evacuation value chain comprising vessels, STS equipment, and operations management processes.</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='projectCardContent'>
                  <div className='top'>
                    <GoProjectTemplate className='projectIcon' />
                    <div className='projectTitle'>
                      <h6>Commenced 2015</h6>
                      <h5>INDIGENOUS OIL & GAS COMPANY   </h5>
                    </div>
                  </div>

                  <div className="details">
                    <ul>
                      <li>Turnkey Crude Evacuation. </li>
                      <li>Monthly Evacuation of 80,000+ bbls.</li>
                      <li>STS crude evacuation operation with a low draft vessel (Shuttle tanker)</li>

                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Project